/**
 * Book Page
 * Shows list of parshiot for a selected book
 */

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { useAppContext } from '../contexts/AppContext';
import { PARASHA_ORDER_MAP, PARASHA_BEREISHIT_ORDER, PARASHA_SHEMOT_ORDER, PARASHA_VAYIKRA_ORDER, PARASHA_BAMIDBAR_ORDER,PARASHA_DEVARIM_ORDER  } from '../consts/constTora';

const BookPage = () => {
  const { bookId } = useParams();
  const navigate = useNavigate();
  const { manifest, loading, books, selectedBook, setSelectedBook, setSelectedParsha } = useAppContext();
  const [isContactOpen, setIsContactOpen] = useState(false);

  useEffect(() => {
    // Wait until the manifest has loaded so books contain full parsha data.
    if (loading || !manifest) {
      return;
    }

    // Find and set the book based on URL parameter
    if (!selectedBook || selectedBook.id !== bookId) {
      const book = books.find(b => b.id === bookId);
      if (book) {
        setSelectedBook(book);
      } else {
        navigate('/');
      }
    }
  }, [bookId, manifest, loading, books, selectedBook, setSelectedBook, navigate]);

  const handleParshaClick = (parsha) => {
    setSelectedParsha(parsha);
    navigate(`/book/${bookId}/parsha/${encodeURIComponent(parsha.name)}`);
  };

  const handleGoBack = () => {
    navigate('/');
  }
  if (!selectedBook) {
    return (
      <div className="text-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-white">טוען...</p>
      </div>
    );
  }


  const bookOrder = PARASHA_ORDER_MAP[selectedBook.name] || [];
    const parshiot = selectedBook.parshiot.sort((a, b) => {
        const aOrder = bookOrder.indexOf(a.name);
        const bOrder = bookOrder.indexOf(b.name);
        return aOrder - bOrder;
    });
  return (
  <div className="min-h-screen flex flex-col">

    {/* TOP NAV BAR - outside the content div */}
    <div dir="rtl" className="w-full py-4 px-6 flex justify-between items-center">
      
      {/* Contact */}
      <div className="relative">
        <button 
          onClick={() => setIsContactOpen(!isContactOpen)}
          className="flex items-center gap-2 text-amber-300 hover:text-amber-400 transition font-semibold text-base"
        >
          <span>צור קשר</span>
          <span className={`text-[11px] transition-transform ${isContactOpen ? 'rotate-180' : ''}`}>▼</span>
        </button>

        {isContactOpen && (
          <div className="absolute top-full right-0 mt-2 w-72 bg-white rounded-xl shadow-2xl p-2 z-50 text-gray-800 border border-gray-200">
            <a href="mailto:tora2338@gmail.com" className="flex items-center gap-3 p-3 hover:bg-gray-50 rounded-lg transition">
              <span className="text-xl">📧</span>
              <div className="flex flex-col text-right">
                <span className="font-bold text-sm">דברו איתנו במייל</span>
                <span className="text-[11px] text-gray-500">להערות, הארות, לקבלת הדף השבועי במייל הקדשה לעילוי נשמת וכו׳</span>
              </div>
            </a>
            <a  
              href="https://links.payboxapp.com/iBta1etlyWb" 
              target="_blank" 
              rel="noreferrer" 
              className="flex items-center gap-3 p-3 hover:bg-orange-50 rounded-lg transition border-t mt-1"
            >
              <span className="text-xl">💰</span>
              <div className="flex flex-col text-right">
                <span className="font-bold text-sm text-orange-700">תרומה בפייבוקס</span>
                <span className="text-[11px] text-gray-500">עזרו לנו לגדול</span>
              </div>
            </a>
          </div>
        )}
      </div>

      {/* Logo / Title center */}
      <div className="absolute left-1/2 -translate-x-1/2 text-center hidden md:block">
        <span className="text-amber-300 font-bold text-lg md:text-xl tracking-wide">📖 הלכה בפרשה</span>
      </div>

      {/* App Link */}
      <a 
        href="https://play.google.com/store/apps/details?id=com.halachaparasha.app" 
        target="_blank" 
        rel="noreferrer" 
        className="font-semibold text-base text-amber-300 hover:text-amber-400 transition"
      >
        מעבר לאפליקציה 📱
      </a>
    </div>

    {/* Page Content */}
    <div className="space-y-4 flex justify-center">
      <div className="w-full max-w-[1200px] px-2 md:px-4 mt-6">

        {/* Back Button */}
        <div className="mb-2">
          <button
            onClick={() => handleGoBack()}
            className="flex items-center gap-1 text-amber-600 hover:text-amber-800 transition font-semibold text-lg md:text-xl"
          >
            ← חזור
          </button>
        </div>

        {/* Book Header */}
        <div className="bg-white rounded-2xl shadow-lg border-2 border-amber-300 py-4 text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">
            {selectedBook.name}
          </h2>
          <p className="text-gray-600">
            {parshiot.length} פרשיות
          </p>
        </div>

        {/* Parsha List */}
        <div dir="rtl" className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {parshiot.map((parsha, index) => (
            <button
              key={index}
              onClick={() => handleParshaClick(parsha)}
              className="
                bg-white rounded-xl px-4 py-3 
                border border-amber-200
                hover:bg-amber-50 hover:border-amber-300
                transition
                text-right
                card
              "
            >
              <div className="flex items-center justify-start gap-2 text-right">
                <span className="text-xl md:text-2xl font-bold text-gray-800 block">
                  {parsha.name}
                </span>
              </div>
            </button>
          ))}
        </div>
        <div className="h-10"></div>
      </div>
    </div>

  </div>
);

};

export default BookPage;